module.exports = __webpack_public_path__ + "static/54-ba1e4778894f82637b523891e19a0cea.png";